export enum ContentType {
  DOCUMENT = 'DOCUMENT',
  TEMPLATE = 'TEMPLATE',
  SECTION = 'SECTION',
}

import { trackError } from '@proposify/frontend-observability';

// Call in switch `default` branches so TypeScript flags missing cases at compile time.
export function logUnknownContentType(contentType: never): void {
  trackError(new Error(`Unhandled ContentType: ${String(contentType)}`));
}
